import React from "react";
import {AuthStudent} from "../api";
import {Url} from "./authsUrls";

const Class = React.lazy(() => import("../pages/Student/Class/ClassList"))
const ClassDetail = React.lazy(() => import("../pages/Student/Class/ClassDetail"))

const HomeworkList = React.lazy(() => import("../pages/Student/Homeworks/HomeworkList"))
const HomeworkAnswerPage = React.lazy(() => import("../pages/Student/Homeworks/HomeworkAnswerPage"))

export const StudentUrls: Url[] = [
    {Uri: "/student/class/:classID", Comp: ClassDetail, Auth: [AuthStudent], Layout: true},
    {Uri: "/student/class", Comp:Class , Auth: [AuthStudent], Layout: true},
    {Uri: "/student/my_homeworks", Comp: HomeworkList, Auth: [AuthStudent], Layout: true},
    {Uri: "/student/homework/:homeworkId", Comp: HomeworkAnswerPage, Auth: [AuthStudent], Layout: true},
]

